export default {
  es: {
    names: 'Nombres',
    lastNames: 'Apellidos',
    operation: 'Operación',
    createCUR: 'Crear usuario',
    create: 'Nuevo ítem',
    edit: 'Editar usuario',
    deleteCUR: '¿Estás seguro de eliminar este usuario?',
    roleName: 'Nombre del rol',
    userName: 'Nombre de usuario',
    email: 'Email',
    profile: 'Perfil de usuario',
    itemCreated: 'Un nuevo usuario ha sido creado',
    itemUpdated: 'Un usuario ha sido actualizado',
    itemDeleted: 'Un usuario ha sido eliminado',
    defaultClinic: 'Clínica por defecto'
  },
  en: {
    names: 'Names',
    lastNames: 'Last names',
    operation: 'Operation',
    createCUR: 'Create user',
    create: 'New item',
    edit: 'Edit user',
    deleteCUR: 'Do you want to delete this user?',
    roleName: 'Role name',
    userName: 'User name',
    email: 'Email',
    profile: 'User profile',
    itemCreated: 'A new user have been created',
    itemUpdated: 'An user have been updated',
    itemDeleted: 'An user have been deleted',
    defaultClinic: 'Default clinic'
  }
};
